import { Map } from '@library/components/maps';
import { MapSwitch } from '@library/components/switches';
import { MemberProfileMapContext } from '@bo-hooks/members/useMemberProfileMapContext';
import { MemberProfileMapMarkers } from '@bo-components/members/memberProfile';
import { useContext } from 'react';

export const MemberProfileMap = () => {
  const { entriesChecked, isLoading, mapPoints, onEntriesChecked } = useContext(
    MemberProfileMapContext
  );

  // Set the switch to the opposite of entriesChecked to match Figma design
  const switchChecked = !entriesChecked;

  return (
    <div
      className="relative flex flex-col pt-1"
      data-testid="member-profile-map"
    >
      <div
        className="absolute -top-9 right-0 flex items-center gap-3"
        data-testid="member-profile-map-toggle"
      >
        <span className="text-soClean-180 text-sm" data-testid="entries">
          Entries
        </span>
        <MapSwitch
          checked={switchChecked}
          disabled={isLoading}
          handleChange={onEntriesChecked}
        />
        <span className="text-soClean-180 text-sm" data-testid="sign-in">
          Sign Ins
        </span>
      </div>
      <Map
        data-testid="map"
        mapCenter={mapPoints.length ? mapPoints[0].position : undefined}
      >
        <MemberProfileMapMarkers />
      </Map>
    </div>
  );
};
